import React from "react";
import { info } from "@randajan/simple-app/fe";
import jet from "@randajan/jet-core";

import { LandingPage } from "./LandingPage/LandingPage";
import { createRouter } from "@randajan/jet-react/dom/router";

import page from "@randajan/jet-react/base/page";
import tab from "@randajan/jet-react/base/tab";

const pages = [
  { title:"", path:"/", content:<LandingPage/>, titleMenu:"" },
];



export const Router = createRouter(pages);

tab.fit("title", (next, value)=>{
  const route = Router.matchRoute(page.get("pathname"));
  return jet.melt([route.title, info.title], " | ");
});

page.watch(_=>tab.set("title"));